import styled from 'styled-components';
import colors from 'styles/colors';

export const Shadow = styled.div`
  background: ${colors.palette.gray['005']};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  height: 1px;
  width: 100vw;
`;
